import {EventDispatcher} from "../EventDispatcher.js";

export class PointModeIndicator extends EventDispatcher {
  constructor(viewer) {
    super();
    
    this.viewer = viewer;
    this.currentMode = 'create';
    this.indicatorElement = null;
    
    this.createIndicator();
    this.setupEventListeners();
  }

  createIndicator() {
    // Create the mode indicator HTML
    this.indicatorElement = document.createElement('div');
    this.indicatorElement.id = 'point-mode-indicator';
    this.indicatorElement.className = 'fixed top-4 right-4 bg-white border border-gray-300 rounded-lg shadow-lg z-40 px-3 py-2';
    this.indicatorElement.style.display = 'none';
    
    this.updateIndicatorContent();
    document.body.appendChild(this.indicatorElement);
  }

  updateIndicatorContent() {
    const modeText = this.currentMode === 'create' ? 'Create Point' : 'Move Point';
    const modeColor = this.currentMode === 'create' ? 'bg-green-500' : 'bg-blue-500';
    
    this.indicatorElement.innerHTML = `
      <div class="flex items-center space-x-2">
        <div class="w-3 h-3 rounded-full ${modeColor}"></div>
        <span class="text-sm font-medium text-gray-700">${modeText}</span>
        <button id="mode-toggle-btn" class="text-xs text-blue-600 hover:text-blue-800 underline">
          Switch
        </button>
      </div>
    `;
    
    // Add click handler for the switch button
    const switchBtn = this.indicatorElement.querySelector('#mode-toggle-btn');
    if (switchBtn) {
      switchBtn.addEventListener('click', () => {
        this.toggleMode();
      });
    }
  }

  setupEventListeners() {
    // Set up mode change listener after a short delay to ensure InputHandler is ready
    setTimeout(() => {
      if (this.viewer.inputHandler && this.viewer.inputHandler.contextMenu) {
        console.log('PointModeIndicator: Setting up mode change listener');
        this.viewer.inputHandler.addEventListener('point_mode_changed', (e) => {
          console.log('PointModeIndicator: Received mode change to', e.mode);
          this.setMode(e.mode);
        });
      }
    }, 100);
  }

  show() {
    this.indicatorElement.style.display = 'block';
    this.dispatchEvent({ type: 'indicator_shown' });
  }

  hide() {
    this.indicatorElement.style.display = 'none';
    this.dispatchEvent({ type: 'indicator_hidden' });
  }

  setMode(mode) {
    this.currentMode = mode;
    this.updateIndicatorContent();
    this.dispatchEvent({ type: 'mode_changed', mode: this.currentMode });
  }

  toggleMode() {
    const newMode = this.currentMode === 'create' ? 'move' : 'create';
    this.setMode(newMode);
    
    // Also update the context menu if it exists
    if (this.viewer.inputHandler && this.viewer.inputHandler.contextMenu) {
      this.viewer.inputHandler.contextMenu.setMode(newMode);
    }
  }

  getCurrentMode() {
    return this.currentMode;
  }

  dispose() {
    if (this.indicatorElement && this.indicatorElement.parentNode) {
      this.indicatorElement.parentNode.removeChild(this.indicatorElement);
    }
  }
}
